import axios from "@axios";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  namespaced: true,
  state: {
    items: [],
    models: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map(access_devices => ({
        value: access_devices.id,
        label: access_devices.name,
      }));
    },
    getSelectedModels(state) {
      return state.models.map(access_models => ({
        value: access_models.id,
        label: access_models.description,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    setDataModel(state, value) {
      state.models = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get("v1/access_device", {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });

      if (!response.data) {
        return [];
      }
      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        const { t } = useI18nUtils();
        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "Dispositivos De Acceso",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de Dispositivos De Acceso",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async sync() {
      const { data } = await axios.get("v1/access_device/sync");

      if (!data) {
        return [];
      }

      return data;
    },
    async addDevice(_, req) {
      const { data } = await axios.post("v1/access_device", req);

      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/access_device/${id}`, params);

      return data;
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/access_device/${id}`);

      return data;
    },
    async getmodels({ commit }) {
      const { data } = await axios.get(`v1/access_device/models`);
      commit("setDataModel", data.data);
      return data;
    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
